module.exports = __webpack_public_path__ + "img/car_1.51d740cf.jpeg";